// extracted by mini-css-extract-plugin
export default {"textArea":"textArea-TNUSTX2w"};